/* eslint-disable no-restricted-globals */

import { trimAttribute } from '../utils';
const PREV_URL_KEY = 'pushpay-analytics-prevUrl';
const proxyHistoryMethod = method => callBack => {
  const originalMethod = history[method].bind(history);
  history[method] = (stateObj, unused, url) => {
    const {
      origin,
      pathname
    } = new URL((url === null || url === void 0 ? void 0 : url.toString()) || '', window.location.origin);
    callBack(`${origin}${pathname}`);
    originalMethod(stateObj, unused, url);
  };
  return function reset() {
    history[method] = originalMethod;
  };
};
let resetToOriginPushState;
let resetToOriginReplaceState;
export function trackPageView(record, config) {
  const track = nextURL => {
    if (!config.enable) {
      if (resetToOriginPushState) {
        resetToOriginPushState();
      }
      if (resetToOriginReplaceState) {
        resetToOriginReplaceState();
      }
      return;
    }
    const {
      location: {
        origin,
        pathname
      }
    } = window;
    const url = nextURL || `${origin}${pathname}`;
    const prevUrl = sessionStorage.getItem(PREV_URL_KEY);
    if (url === prevUrl) {
      return;
    }
    const systemAttributes = {};
    const systemAttributesRaw = {
      url,
      ...config.attributes
    };
    Object.entries(systemAttributesRaw).forEach(([key, value]) => {
      systemAttributes[key] = value ? trimAttribute(value) : value;
    });
    const pageViewEvent = {
      name: 'pageView',
      attributes: systemAttributes
    };
    record(pageViewEvent);
    sessionStorage.setItem(PREV_URL_KEY, url);
  };
  const bindEventListeners = () => {
    resetToOriginPushState = proxyHistoryMethod('pushState')(track);
    resetToOriginReplaceState = proxyHistoryMethod('replaceState')(track);
    window.addEventListener('popstate', () => track());
  };
  bindEventListeners();
  // Record a page view on initial page load
  track();
}